<script lang="ts">
    import Home from "./views/Home.svelte";
    import MyNavbar from "./views/MyNavbar.svelte";
    import ResultsList from "./views/ResultsList.svelte";
    import AddAudioRecording from "./views/contributors/AddAudioRecording.svelte";
    import Router from "svelte-spa-router";
    import { link } from "svelte-spa-router";
    import Container from "./materialize/grid/Container.svelte";
    import LoadingScreen from "./views/subcomponents/LoadingScreen.svelte";
    import NoInternetConnection from "./views/NoInternetConnection.svelte";
    import {
        languages,
        genders,
        numbers,
        lexical_categories,
        scopes,
        current_dialect,
        italian_language,
        is_online,
        allow_analytics,
    } from "./stores/stores";
    import { get_host } from "./settings";
    import { Language } from "./dictionary/Language";
    import { Gender } from "./dictionary/Gender";
    import { Number } from "./dictionary/Number";
    import Tutorial from "./views/Tutorial.svelte";
    import { LexicalCategory } from "./dictionary/LexicalCategory";
    import { Scope } from "./dictionary/Scope";
    import SingleWordView from "./views/SingleWordView.svelte";
    import ContributorsHomepage from "./views/contributors/ContributorsHomepage.svelte";
    import AddNewWord from "./views/contributors/AddNewWord.svelte";
    import Gdpr from "./views/GDPR.svelte";
import RandomWord from "./views/subcomponents/recording/RandomWord.svelte";
import ManageAudioRecordings from "./views/contributors/ManageAudioRecordings.svelte";
import Privacy from "./views/Privacy.svelte";
    

    const routes = {
        "/": Home,
        "/privacy": Privacy,
        "/search/:pk_language/:word": ResultsList,
        "/ricerca/:pk_language/:word": ResultsList,
        "/parola/:pk_word": SingleWordView,
        "/tutorial": Tutorial,
        "/contribute": ContributorsHomepage,
        "/contribute/word/add": AddNewWord,
        "/contribute/audio": ManageAudioRecordings,
        "/contribute/audio/random": RandomWord,//Here the id word will be fetched randomly
        "/contribute/audio/:pk_word": AddAudioRecording,
        "*": Home,
    };

    let initialization_promises = Promise.all([
        //new Promise((resolve) => setTimeout(resolve, 3000)),
        fetch(get_host() + "/api/dictionary/init/language")
            .then((r) => {
                if (r.ok) {
                    return r;
                } else {
                    throw new Error("Error retrieving languages");
                }
            })
            .then((r) => r.json())
            .then((arr) => {
                $languages = [];
                arr.forEach((el) => $languages.push(new Language(el)));
                $languages = $languages;
                $italian_language = $languages.find((l) => l.iso_code === "it");
            }),
        fetch(get_host() + "/api/dictionary/init/gender")
            .then((r) => {
                if (r.ok) {
                    return r;
                } else {
                    throw new Error("Error retrieving gender");
                }
            })
            .then((r) => r.json())
            .then((arr) => {
                $genders = [];
                arr.forEach((el) => {
                    $genders.push(new Gender(el));
                });
                $genders = $genders;
                console.log($genders);
            }),
        fetch(get_host() + "/api/dictionary/init/number")
            .then((r) => {
                if (r.ok) {
                    return r;
                } else {
                    throw new Error("Error retrieving number");
                }
            })
            .then((r) => r.json())
            .then((arr) => {
                $numbers = [];
                arr.forEach((el) => {
                    $numbers.push(new Number(el));
                });
                $numbers = $numbers;
                console.log($numbers);
            }),
        fetch(get_host() + "/api/dictionary/init/lexical_category")
            .then((r) => {
                if (r.ok) {
                    return r;
                } else {
                    throw new Error("Error retrieving lexical categories");
                }
            })
            .then((r) => r.json())
            .then((arr) => {
                $lexical_categories = [];
                arr.forEach((el) => {
                    $lexical_categories.push(new LexicalCategory(el));
                });
                $lexical_categories = $lexical_categories;
                console.log($lexical_categories);
            }),
        fetch(get_host() + "/api/dictionary/init/scope")
            .then((r) => {
                if (r.ok) {
                    return r;
                } else {
                    throw new Error("Error retrieving scopes");
                }
            })
            .then((r) => r.json())
            .then((arr) => {
                $scopes = [];
                arr.forEach((el) => {
                    $scopes.push(new Scope(el));
                });
                $scopes = $scopes;
                console.log($scopes);
            }),
    ]).catch(() => {
        $is_online = false;
    }); //Da spostare in App.svelte
</script>

<main>
    <MyNavbar />
    <Container>
        {#await initialization_promises}
            <LoadingScreen />
        {:then res}
            {#if $is_online}
                <!-- {#if $allow_analytics == 0} -->
                {#if false }
                    <Gdpr></Gdpr>
                {:else}
                    <Router {routes} />
                {/if}
                
            {:else}
                <NoInternetConnection />
            {/if}
        {:catch}
            <NoInternetConnection />
        {/await}
    </Container>
</main>
